// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20tbB","content":"styles_content__1TwZ3","row":"styles_row__2HFK1","footer":"styles_footer__3V85U","phraseLength":"styles_phraseLength__2dA2G"};